const supportPath = () => '/support';

export const supportRequestHomePath = () => `${supportPath()}/request`;
export const supportRequestListPath = () => `${supportPath()}/request/list`;
export const supportRequestJobListPath = (id: string | number = ':id') =>
  `${supportPath()}/request/${id}/job-list`;
export const addSupportRequestJobsPath = () => `${supportPath()}/request/add-jobs`;
export const editSupportRequestJobsPath = (id: string | number = ':id') =>
  `${supportPath()}/request/${id}/edit-jobs`;
